/**
 * @desc 启用
 */
const URL = "/rantion-app-center";
import http, { updateResponse } from "@/http";
export type Response = defs.appCenter.Response;
export function request(code: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/app/enable/${code}`, {
      method: "POST",

      ...options,
    }),
  );
}
